'use client';
import styled from 'styled-components';

export const BoxSummaryContainer = styled.div`
  padding: ${props => props.theme.spacing(6, 4, 10)};
  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(9, 4, 12)};
  }
`;

export const HeaderContainer = styled.div`
  text-align: center;
  padding: ${props => props.theme.spacing(6, 4, 10)};
  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(9, 4, 12)};
  }
`;

export const Headline = styled.h1`
  ${props => props.theme.typography.heading3};
  @media ${props => props.theme.tablet} {
    ${props => props.theme.typography.heading1};
  }
`;

export const Subheadline = styled.p`
  max-width: 398px;
  margin: ${props => props.theme.spacing(2)} auto 0;
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.primary};
  padding-top: ${props => props.theme.spacing(2)};
`;

export const HeroContainer = styled.div`
  display: relative;
  margin-bottom: ${props => props.theme.spacing(16)};

  @media ${props => props.theme.tablet} {
    max-width: 960px;
  }

  @media ${props => props.theme.laptop} {
    margin: auto;
    max-width: 1080px;
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
    min-width: unset;
  }
  legend {
    ${({ theme }) => theme.typography.heading5}
    margin: 0 auto ${({ theme }) => theme.spacing(5)};
  }
`;

export const StyledImageContainer = styled.div`
  text-align: center;
  padding-bottom: ${props => props.theme.spacing(4)};
`;
